<template>
    <div class="page-wrapper qrcode-page">
        <TopBarWhiteCurve
            :title="lbl.qrcode.scan_qr.title"
            @clickBack="clickBack()">
        </TopBarWhiteCurve>
        <div class="page-content">
            <div class="text-camera">{{localePage.scan_qr.text_pls_scan}}</div>
            <div class="area-camera">
                <div class="camera-border border1"></div>
                <div class="camera-border border2"></div>
                <div class="camera-border border3"></div>
                <div class="camera-border border4"></div>
                <div class="error-camera">
                    <div class="error-text" v-html="error"></div>
                </div>

                <!-- <QrcodeStream
                    v-if="reInit"
                    :camera="camera"
                    @decode="onDecode"
                    @init="initialQRCodeReader"
                /> -->
            </div>
            <div class="bottom-bar">
                <div>
                    <TextInput
                        v-model="serialCode"
                        inputId="serial_code"
                        :inputLbl="localePage.code"
                        :isFirstSave="false"
                        :isShowErrorLbl="false"
                        :errorInfo="errorInfo[0]"
                    />
                    <div class="text-code-error" v-if="errorText">{{errorText}}</div>
                </div>
                <div class="btn-confirm-wrapper">
                    <div
                        class="btn-confirm"
                        :class="{ disabled: !serialCode }"
                        @click="clickConfirm()"
                    >
                        {{localePage.scan_qr.btn_confirm}}
                    </div>
                </div>
                <div class="bottom-bar-text" v-html="localePage.scan_qr.text_contact"></div>
            </div>
        </div>

        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
// https://www.npmjs.com/package/vue-qrcode-reader
//import { QrcodeStream } from "vue-qrcode-reader";
// helper
import Account from "@/helper/AccountHelper";
import FormHelper from "@/helper/FormHelper.js";
// mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import TextInput from "@/components/Input/Text.vue";
import TopBarWhiteCurve from '@/components/Layout/TopBarPage/TopBarWhiteCurve.vue';
// service
import CouponService from "@/core/Coupon/CouponService.js";
import ProductPointConfig from "@/core/ProductPointDetail/ProductPointConfig.js";

export default {
    name: "ScanQRCode",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        TextInput,
        //QrcodeStream,
        TopBarWhiteCurve
    },
    data: function() {
        return {
            token: null,
            localePage: {},
            errorInfo: [],
            error: null,
            camera: "auto",
            reInit: true,
            serialCode: null,
            skuCode: null,
            productMaster: [],
            productScan: null,

            autoCampaign: null,
            errorText: '',
        };
    },
    created: function() {
        this.token = Account.getToken();
        this.errorInfo = FormHelper.genErrorInfo(1);
        this.localePage = this.lbl.qrcode;
        this.initialProductDescriptionModal();
        this.initialPointSummaryModal();
    },
    mounted: function() {},
    methods: {
        //event
        clickBack: function () {
            this.$router.push('/point');
            console.log('back');
        },
        clickConfirm: function() {
            if (!this.serialCode) return;

            //get product SKU from API
            this.getProductSKU();
        },
        getProductSKU: function(){
            this.loadingModal.show();
            CouponService.apiGetSKU(this.token, this.serialCode)
                .subscribe(res => {
                    this.loadingModal.hide();
                    console.log('sku', res);
                    var codes = res.data.codes;
                    if(codes){
                        switch (codes[this.serialCode].status){
                            case 'Success':
                                this.skuCode = res.data.codes[this.serialCode].name;
                                this.errorText = "";
                                //get product detail from Blob
                                this.getProductDetail();
                                break;
                            case 'NotFound':
                                this.errorText = this.localePage.errorText.notFound;
                                break;
                            case 'Used':
                                this.errorText = this.localePage.errorText.used;
                                break;
                        }
                    }

                    this.reInit = false;
                    this.$nextTick(() => {
                        this.reInit = true;
                    });

                },err => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                }
            );
        },
        getProductDetail: function(){
            this.loadingModal.hide();
            ProductPointConfig.apiGetProductMaster().subscribe(res =>{
                console.log('product', res);
                this.productMaster = res;
                this.productScan = this.productMaster.filter(k => k.skucode == this.skuCode)[0];

                //show product description
                setTimeout(() =>{
                    this.productDescriptionModal
                        .setTag('product-detail')
                        .setName(this.productScan.text)
                        .setDetail(this.productScan.description)
                        .setPoint(this.productScan.point)
                        .show();

                    this.productDescriptionModal.onClickOk(res => {
                        var selected = res.data;
                        this.callAPICoupon(selected);
                    });
                },500)

            },err =>{
                this.loadingModal.hide();
                this.errorApi(err);
            });
        },
        callAPICoupon: function(selected) {
            // detect inject code
            this.loadingModal.show();
            //call api
            CouponService.apiPostCoupon(this.token, this.serialCode, selected)
            .subscribe(res => {
                    console.log('point', res);
                    this.loadingModal.hide();

                    //get point earn
                    var code_earn = res.data.codes[this.serialCode];
                    var point_earn = 0;
                    if(code_earn){
                        if(code_earn.status == 'Success'){
                            point_earn = code_earn.detail.Points;

                            //auto redeem
                            if (code_earn.detail && code_earn.detail.buzzebees) {
                                var badges = code_earn.detail.buzzebees.badges;

                                if (badges) {
                                    console.log("badges", badges);

                                    // var redeem = badges.filter(
                                    //     o => o.id == "BiodermaCoupon4_23213185"
                                    // )[0];
                                    var redeem = badges.filter(o => (o.id.indexOf("BiodermaCoupon4") >= 0))[0];
                                    console.log("autoredeem", redeem);

                                    if(redeem && redeem.auto_redeem){
                                        this.autoCampaign = redeem.auto_redeem;
                                    }
                                }
                            }
                        }
                    }

                    //show summary modal
                    this.pointSummaryModal
                        .setCampaign(this.autoCampaign)
                        .setPoint(point_earn)
                        .setTag('point-summary')
                        .show();

                    this.pointSummaryModal.onClickOk((data) =>{
                        if(data.tag == 'point-summary'){
                            document.getElementById("serial_code").value = "";
                        }
                    });

                    this.pointSummaryModal.onClickPage((data) =>{
                        if(data.tag == 'point-summary'){
                            this.$router.push('/history/earn');
                        }
                    });

                },err => {
                    this.loadingModal.hide();
                    console.log(this.alertModal);
                    this.errorApi(err);
                }
            );
        },
        onDecode(result) {
            this.serialCode = result;
            console.log('code',this.serialCode);
            this.clickConfirm();
        },
        initialQRCodeReader: async function(promise) {
            try {
                await promise;
            } catch (error) {
                var txt = "";
                if (error.name === "NotAllowedError") {
                    txt = "ERROR: you need to grant camera access permisson";
                } else if (error.name === "NotFoundError") {
                    txt = "ERROR: no camera on this device";
                } else if (error.name === "NotSupportedError") {
                    txt = "ERROR: secure context required (HTTPS, localhost)";
                } else if (error.name === "NotReadableError") {
                    txt = "ERROR: is the camera already in use?";
                } else if (error.name === "OverconstrainedError") {
                    txt = "ERROR: installed cameras are not suitable";
                } else if (error.name === "StreamApiNotSupportedError") {
                    txt = "ERROR: Stream API is not supported in this browser";
                } else {
                    txt = `ERROR: ${error.toString()}`;
                }
                this.error = txt;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./../style/ScanQRCode.scss";
</style>
